var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyFailedSched(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1263 1371",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8795.43,-2244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7",
    transform: "matrix(0.509162,0,0,0.390689,8795.43,2244)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2480.32,
    height: 3507.87
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.9745,0,0,22.1218,695.307,52.9828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,51C102,22.852 79.148,0 51,0C22.852,0 0,22.852 0,51L0,106C0,134.148 22.852,157 51,157C79.148,157 102,134.148 102,106L102,51Z",
    style: {
      fill: "rgb(241,248,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09741,0,0,1.17959,-137.911,-191.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-326.047,-1217.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 899.734,1113.06 821.033,1133.79C769.556,1147.34 725.405,1180.46 697.983,1226.09C653.356,1300.34 589.813,1406.07 589.813,1406.07L772.972,1566.3L824.373,1504.29C824.373,1504.29 888.09,1706.17 888.555,1762.93C889.02,1819.69 868.453,1980.87 868.453,1980.87L1346.04,1980.87C1346.04,1980.87 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1335.67,1633.55 1335.67,1633.55C1335.67,1633.55 1349.16,1632.45 1367.44,1630.96C1424.63,1626.3 1470.84,1582.41 1478.44,1525.53C1485.51,1472.6 1494.49,1405.46 1502.78,1343.38C1516.52,1240.58 1451.03,1143.8 1350.49,1118.33C1275.97,1099.44 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z",
    style: {
      fill: "rgb(9,89,217)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1007.97,1084.55C1007.97,1084.55 899.734,1113.06 821.033,1133.79C769.556,1147.34 725.405,1180.46 697.983,1226.09C653.356,1300.34 589.813,1406.07 589.813,1406.07L772.972,1566.3L824.373,1504.29C824.373,1504.29 888.09,1706.17 888.555,1762.93C889.02,1819.69 868.453,1980.87 868.453,1980.87L1346.04,1980.87C1346.04,1980.87 1323.59,1800.68 1325,1753.94C1326.4,1707.2 1335.67,1633.55 1335.67,1633.55C1335.67,1633.55 1349.16,1632.45 1367.44,1630.96C1424.63,1626.3 1470.84,1582.41 1478.44,1525.53C1485.51,1472.6 1494.49,1405.46 1502.78,1343.38C1516.52,1240.58 1451.03,1143.8 1350.49,1118.33C1275.97,1099.44 1206.1,1081.74 1206.1,1081.74L1007.97,1084.55Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1017.21,607.926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1847.9,1000.16L1568.93,873.462C1568.93,873.462 1634.07,864.769 1703.35,873.2C1781.76,882.742 1877.57,827.557 1877.57,827.557C1877.57,827.557 1886.74,838.994 1899.24,854.598C1941.83,907.763 2010.02,933.468 2077.11,921.645C2166.27,905.931 2277.81,886.272 2277.81,886.272L2345.87,989.265L2406.5,1310.88C2406.5,1310.88 2276.7,1149.93 2228.36,1114.81C2161.24,1066.05 2104.91,1078.67 2066.65,1097.6C1979.05,1140.94 1867.78,1321.4 1867.78,1321.4L1847.9,1000.16ZM2209.42,537.3C2209.42,537.3 2255.36,553.57 2298.11,568.708C2338.71,583.087 2361.41,626.298 2350.2,667.888C2337.78,713.969 2324.12,764.627 2324.12,764.627L2345.99,989.418L2354.82,1037.3L2485.77,1036.81C2485.77,1036.81 2532.26,886.084 2536.22,877.923C2571.02,806.131 2537.52,613.508 2548.19,601.9C2548.19,601.9 2470.06,524.823 2470.06,524.823L2160.12,421.228L2209.42,537.3Z",
    style: {
      fill: "rgb(23,64,212)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,51.4616,-5.85918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1056.56,
    cy: 1138.61,
    rx: 144.58,
    ry: 136.035,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.66218,-0.804363,-0.663423,2.01529,4514.33,155.672)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.973037,-0.230649,0.230649,0.973037,-286.128,383.071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1432.21,1565.16C1432.21,1565.16 1436.29,1623.61 1440.45,1683.1C1442.63,1714.19 1458.31,1742.77 1483.37,1761.31C1508.43,1779.85 1540.35,1786.48 1570.72,1779.47C1570.72,1779.47 1570.72,1779.47 1570.72,1779.47C1585.48,1776.06 1598.99,1768.55 1609.68,1757.81C1654.83,1711.69 1784.91,1572.11 1903.02,1380.08L1843.59,1314.65L1614.96,1545.11L1432.21,1565.16Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1432.21,1565.16C1432.21,1565.16 1436.29,1623.61 1440.45,1683.1C1442.63,1714.19 1458.31,1742.77 1483.37,1761.31C1508.43,1779.85 1540.35,1786.48 1570.72,1779.47C1570.72,1779.47 1570.72,1779.47 1570.72,1779.47C1585.48,1776.06 1598.99,1768.55 1609.68,1757.81C1654.83,1711.69 1784.91,1572.11 1903.02,1380.08L1843.59,1314.65L1614.96,1545.11L1432.21,1565.16Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817027,0.576599,0.576599,0.817027,1855.86,-577.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1413.72,1591.5C1413.72,1591.5 1561.88,1522.96 1667.77,1592.34L1568.11,1397.06L1388.51,1521.27L1413.72,1591.5Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.709404,0.704802,-0.704802,0.709404,1417.73,-1046.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.918715,0.394922,-0.440497,0.899124,711.591,-672.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.4,1199.1 2069.96,1216.61C2070.18,1223.37 2069.14,1230.05 2066.9,1236.31C2060.95,1252.96 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.925719,0.378211,-0.378211,0.925719,603.401,-669.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2042.96,1169.51L2068.3,1165.26C2068.3,1165.26 2069.28,1195.58 2069.87,1213.67C2070.15,1222.32 2068.37,1230.92 2064.68,1238.76C2057.98,1252.97 2047.69,1274.81 2047.69,1274.81L2040.91,1220.06Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.927321,0.374266,-0.374266,0.927321,558.265,-653.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2039.96,1241.49L2042.96,1169.51L2066.81,1165.45L2067.61,1198.41L2091.28,1191.92L2070.3,1226.84L2039.96,1241.49Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.626279,0.779599,-0.810667,0.587606,1743.35,-1096.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.39,1147.52 2025.87,1133.96C2023.08,1128.16 2025.3,1121.42 2030.88,1118.74C2030.88,1118.74 2030.88,1118.74 2030.88,1118.74C2036.44,1116.06 2043.33,1118.46 2046.35,1124.12C2054.34,1139.1 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707375,0.706839,-0.706839,0.707375,1434.37,-1087.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2044.9,1173.1C2044.9,1173.1 2032.73,1148.02 2025.71,1133.55C2024.43,1130.9 2024.25,1127.85 2025.22,1125.07C2026.18,1122.3 2028.22,1120.02 2030.87,1118.74C2030.87,1118.74 2030.87,1118.74 2030.87,1118.74C2036.48,1116.04 2043.22,1118.24 2046.15,1123.73C2054.1,1138.64 2068.31,1165.27 2068.31,1165.27L2066.49,1167.26L2044.9,1173.1Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.469998,-0.30218,0.249232,0.387646,786.468,826.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.648884,2.02224,-1.66791,0.786735,2157.22,-2720.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1904.73,1314.87C1904.73,1314.87 1899.64,1299.54 1895.04,1285.66C1890.27,1271.26 1889.25,1255.88 1892.09,1240.97C1895.24,1224.43 1898.95,1204.91 1898.95,1204.91L1931.78,1218.41C1931.78,1218.41 1942.25,1207.18 1952.28,1196.43C1956.33,1192.08 1962.29,1190.02 1968.16,1190.95C1974.04,1191.87 1979.08,1195.65 1981.6,1201.04C1981.6,1201.04 1981.6,1201.04 1981.6,1201.04L1941.13,1277.36L1904.73,1314.87Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.182392,-2.15859,-1.78036,-0.22114,3170.51,6523.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1931.69,1186.11 1947.45,1177.13C1952.26,1174.39 1958.31,1175.25 1962.16,1179.21C1962.16,1179.21 1962.16,1179.21 1962.16,1179.21C1964.63,1181.75 1965.9,1185.22 1965.66,1188.75C1965.41,1192.29 1963.68,1195.55 1960.88,1197.72C1948.58,1207.27 1930.37,1221.42 1930.37,1221.42L1898.62,1204.95Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.642726,0.766096,-0.766096,0.642726,1597.38,-1119.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2042.96,1169.51C2042.96,1169.51 2032.18,1147.1 2025.68,1133.58C2023.02,1128.04 2025.35,1121.4 2030.88,1118.74C2030.88,1118.74 2030.88,1118.74 2030.88,1118.74C2036.48,1116.04 2043.2,1118.25 2046.11,1123.74C2054.13,1138.91 2068.62,1166.29 2068.62,1166.29L2066.49,1167.26L2042.96,1169.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1886.44,1335.42C1882.89,1321.4 1885.39,1306.53 1893.33,1294.44C1901.27,1282.35 1913.92,1274.15 1928.19,1271.84C1960.95,1266.52 1996.03,1260.83 1996.03,1260.83L2063.49,1229.74L2094.06,1234.41C2094.06,1234.41 2074.66,1266.14 2063.41,1284.54C2058.33,1292.84 2050.69,1299.28 2041.64,1302.88C2002.28,1318.53 1893.14,1361.92 1893.14,1361.92C1893.14,1361.92 1890.14,1350.06 1886.44,1335.42Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.712393,0.70178,-0.70178,0.712393,1454.71,-1061.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06L2043.74,1168.54L2053.45,1158.03L2068.49,1165.25L2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.359449,0.933165,-0.933165,0.359449,2453.97,-1128.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2048.83,1181.71C2048.83,1181.71 2033.69,1150.23 2025.69,1133.59C2023.02,1128.05 2025.35,1121.39 2030.89,1118.73C2030.89,1118.73 2030.89,1118.73 2030.89,1118.73C2036.49,1116.03 2043.22,1118.22 2046.16,1123.7C2054.16,1138.6 2068.48,1165.26 2068.48,1165.26L2048.83,1181.71Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,0.864468,2928.08,90.6187)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-726.088,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.55,783.328L1217.88,875.608L1194.05,883.916L1002.92,1021.74L993.138,937.112L1176.61,798.509L1210.55,783.328Z",
    style: {
      fill: "rgb(6,19,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-726.088,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.562,1132.75C996.562,1131.4 1006.15,931.812 1006.15,931.812L1010.11,805.778L1200.63,966.937L1217.42,1123.17C1217.42,1123.17 1217.88,1129.54 1217.88,1132.75C1217.88,1190.21 1168.29,1236.87 1107.22,1236.87C1046.14,1236.87 996.562,1190.21 996.562,1132.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-\\u041A\\u0440\\u0438\\u0432\\u0430\\u044F-",
    transform: "matrix(-0.994896,-0.100909,-0.100909,0.994896,2342.32,119.351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.413,1145.18C991.413,1145.18 1010.22,1105.14 1024.57,1074.59C1034.34,1053.8 1055.26,1040.53 1078.23,1040.56C1089.09,1040.58 1098.07,1040.59 1098.07,1040.59L993.281,902.438L991.413,1145.18Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,2195.03,7.82053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081.89,1037.51C1081.89,1037.51 1099.57,1038.19 1117.86,1038.89C1140.15,1039.75 1157.77,1058.06 1157.77,1080.36C1157.77,1146.49 1157.77,1271.53 1157.77,1271.53L1384.15,1066.07L1192.43,931.554L1163.31,930.84L1081.89,1037.51Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78314,0.214411,0.152875,2.50091,3101.34,-1781.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1182.8,829.067L1204.4,814.798L1208.88,882.235C1208.88,882.235 1221.71,863.558 1240.16,873.229C1263.62,885.527 1266.42,940.973 1209.51,943.453L1177.21,953.994L1182.8,829.067Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996345,-0.08542,0.08542,0.996345,-69.2749,125.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1198.6,926.866L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-742.346,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.08555,17.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.13,891.407C1203.13,891.407 1216.18,861.972 1240.16,873.229C1264.14,884.485 1266.42,940.973 1209.51,943.453L1203.13,891.407Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-726.088,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.45,1073.5 1082.43,1035.85C1067.72,1029.25 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192,806.895C1206.57,860.505 1213.32,916.317 1215.96,993.022C1215.96,993.022 1166.45,1073.5 1082.43,1035.85C1067.72,1029.25 1032.14,1000.99 1032.14,1000.99C1032.14,1000.99 1009.2,928.168 1014.33,833.582C1019.13,745.117 1054.75,751.427 1054.75,751.427L1192,806.895Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1139.54,958.416 1112.67,947.414L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.984234,-0.176872,0.176872,0.984234,-146.205,85.8376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.27,873.138L1158.74,944.985C1158.74,944.985 1053.25,957.559 1015.04,886.977L1131.27,873.138Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.995733,0.0922771,0.0922771,0.995733,2167.6,-94.0271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040.71,860.602L1070.97,845.406L1108.26,851.058L1092.94,863.021L1069.43,854.485L1040.71,860.602Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999523,0.0308927,-0.0308927,0.999523,30.7507,-45.6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1029.29,870.664L1056.11,850.009L1093.8,848.49L1081.02,863.139L1056.32,859.216L1029.29,870.664ZM1085.52,864.318L1100,848.49L1107.09,848.1L1091.45,865.162L1085.52,864.318Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-726.088,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1035.21,773.294C1035.21,773.294 1152.65,853.022 1227.65,791.222C1227.65,791.222 1251.66,771.063 1267.88,715.731C1267.88,715.731 1234.4,697.261 1194.05,698.691L1196.88,679.63C1196.88,679.63 1129.37,674.664 1092.03,713.884L1092.03,687.487C1092.03,687.487 1052.64,731.568 1025.02,737.448C997.398,743.328 993.637,741.917 993.637,741.917C986.58,785.704 984.889,828.665 989.446,870.664C998.491,871.329 1004.56,875.182 1009.21,880.553C1009.21,880.553 1018.33,788.288 1035.21,773.294Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-715.127,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1168.72,875.316C1169.77,874.488 1176.53,875.282 1177.75,877.252C1178.59,878.6 1179.09,880.274 1179.09,882.086C1179.09,886.545 1176.08,890.165 1172.38,890.165C1168.68,890.165 1165.67,886.545 1165.67,882.086C1165.67,879.253 1166.88,876.759 1168.72,875.316Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-726.088,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1159.85,876.386C1159.85,876.386 1177.7,867.585 1191.32,882.086C1191.32,882.086 1180.99,875.402 1159.8,880.894L1159.85,876.386Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.78968,0,0,2.51009,3302.68,-1525.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1161.6,875.244C1161.6,875.244 1177.8,868.956 1191.32,882.086C1191.32,882.086 1182.1,876.547 1162.52,880.271C1162.05,880.359 1161.49,881.365 1161.01,881.465L1161.6,875.244Z",
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.51009,-885.271,-1525.95)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1172.38,
    cy: 882.086,
    rx: 6.709,
    ry: 8.079,
    style: {
      fill: "rgb(14,27,91)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,1.92553,-769.273,-953.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1123.16,990.794C1123.22,988.792 1123.9,986.91 1125.06,985.581C1126.21,984.252 1127.72,983.59 1129.25,983.748C1130.66,983.894 1132.17,984.049 1133.56,984.193C1136.63,984.51 1138.97,987.895 1138.9,991.905C1138.9,991.906 1138.9,991.907 1138.9,991.908C1138.86,993.806 1138.25,995.608 1137.19,996.91C1136.13,998.212 1134.71,998.906 1133.26,998.838C1131.79,998.769 1130.2,998.694 1128.71,998.625C1127.18,998.553 1125.73,997.686 1124.69,996.216C1123.64,994.747 1123.09,992.796 1123.16,990.795C1123.16,990.795 1123.16,990.794 1123.16,990.794Z",
    style: {
      fill: "rgb(251,155,90)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.37986,1.82143,1.39762,1.79829,2431.27,-4510.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1904.73,1314.87C1904.73,1314.87 1899.64,1299.54 1895.04,1285.66C1890.27,1271.26 1889.25,1255.88 1892.09,1240.97C1895.24,1224.43 1898.95,1204.91 1898.95,1204.91L1935.62,1223.9L1968.68,1207.41L1941.13,1277.36L1904.73,1314.87Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.348347,-2.519,1.93287,-0.453979,-196.465,6545.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.62,1204.95C1898.62,1204.95 1930.84,1186.59 1946.83,1177.48C1952,1174.53 1958.51,1175.45 1962.66,1179.72C1962.66,1179.72 1962.66,1179.72 1962.66,1179.72C1965.1,1182.22 1966.43,1185.59 1966.37,1189.08C1966.3,1192.57 1964.84,1195.89 1962.32,1198.3C1951.51,1208.61 1935.39,1224 1935.39,1224L1898.62,1204.95Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.95735,0.210597,0.161595,2.5509,5159.42,-2230.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u0444",
    d: "M1606.5,1551.61C1569.14,1591.81 1567.12,1653.39 1601.76,1695.96C1601.76,1695.96 1601.76,1695.96 1601.76,1695.96C1620.12,1718.51 1648.54,1730.38 1677.48,1727.59C1706.42,1724.79 1732.05,1707.7 1745.75,1682.05C1819.65,1543.73 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1890.81,1245.71C1890.81,1245.71 1707.62,1442.82 1606.5,1551.61Z",
    style: {
      fill: "rgb(240,163,111)"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u04441",
    d: "M1606.5,1551.61C1569.14,1591.81 1567.12,1653.39 1601.76,1695.96C1601.76,1695.96 1601.76,1695.96 1601.76,1695.96C1620.12,1718.51 1648.54,1730.38 1677.48,1727.59C1706.42,1724.79 1732.05,1707.7 1745.75,1682.05C1819.65,1543.73 1933.77,1330.13 1933.77,1330.13L1921.81,1256.88L1890.81,1245.71C1890.81,1245.71 1707.62,1442.82 1606.5,1551.61Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2249.34,995.436C2249.34,995.436 2249.34,995.436 2249.34,995.436C2289.22,1012.23 2335.35,1002 2364.4,969.93C2393.44,937.861 2399.07,890.945 2378.43,852.919C2287.61,685.617 2185.6,497.703 2185.6,497.703L2003.37,575.284L2249.34,995.436Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.997006,0.0773221,-0.0773221,0.997006,101.132,-152.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.977656,0.210211,0.23343,-1.08564,-259.646,2101.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.971079,0.238758,0.265129,-1.07834,-301.21,2005.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.633437,-0.90265,-0.818558,0.574425,4302.9,2391.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2041.6,1197.58 2042.1,1181.73C2042.22,1177.77 2043.83,1174.04 2046.54,1171.45C2049.25,1168.85 2052.82,1167.61 2056.39,1168.03C2056.65,1168.06 2056.91,1168.09 2057.17,1168.12C2063.56,1168.86 2068.49,1174.68 2068.74,1181.76C2069.32,1198.64 2070.3,1226.84 2070.3,1226.84L2053.78,1234.16L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.817077,-0.576529,-0.576529,0.817077,4382.05,1386.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2048.21,1179.03C2048.21,1179.03 2033.49,1152.53 2024.47,1136.3C2022.72,1133.15 2022.38,1129.4 2023.54,1125.99C2024.71,1122.57 2027.26,1119.81 2030.57,1118.38C2030.57,1118.37 2030.57,1118.37 2030.57,1118.37C2036.46,1115.83 2043.33,1118.1 2046.53,1123.66C2057.07,1141.9 2078.73,1179.4 2078.73,1179.4L2048.21,1179.03Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.419652,-0.907685,-0.907685,0.419652,3993.3,2629.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.601081,-0.799188,0.887462,-0.667472,2230.44,3642.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2042.48,1191.87 2043.39,1175.44C2043.56,1172.4 2045.08,1169.54 2047.6,1167.51C2050.12,1165.48 2053.44,1164.44 2056.82,1164.63C2056.82,1164.63 2056.82,1164.63 2056.82,1164.63C2063.32,1164.99 2068.45,1169.76 2068.64,1175.62C2068.99,1186.36 2069.53,1203.14 2069.9,1214.54C2069.99,1217.45 2068.56,1220.23 2066.04,1222.04C2063.51,1223.86 2060.19,1224.51 2057.06,1223.78C2049.26,1221.98 2040.91,1220.06 2040.91,1220.06Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.990108,0.140308,-0.140308,0.990108,203.717,-266.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2040.91,1220.06C2040.91,1220.06 2040.69,1195.67 2040.55,1179.17C2040.51,1175.29 2042.06,1171.57 2044.83,1168.87C2047.61,1166.16 2051.37,1164.7 2055.24,1164.83C2055.24,1164.83 2055.24,1164.83 2055.24,1164.83C2062.59,1165.07 2068.49,1170.98 2068.73,1178.33C2069.09,1189.69 2069.62,1205.93 2069.96,1216.43C2070.18,1223.31 2069.11,1230.16 2066.79,1236.64C2060.79,1253.38 2049.22,1285.72 2049.22,1285.72L2040.91,1220.06Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.525657,-0.850697,-0.850697,0.525657,4103.91,2314.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2041.07,1226.04C2041.07,1226.04 2040.46,1198.26 2040.07,1180.46C2039.89,1172.41 2046.27,1165.74 2054.32,1165.57C2054.32,1165.57 2054.32,1165.57 2054.32,1165.57C2062.19,1165.39 2068.74,1171.56 2069.05,1179.42C2069.8,1198.72 2071.07,1230.9 2071.07,1230.9L2053.78,1234.16L2041.07,1226.04Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.992416,-0.122924,-0.122924,0.992416,4126.78,1010.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788L2075.66,421.558C2073.31,420.364 2070.36,419.725 2068.33,419.893L2058.58,413.585L2084.95,398.971C2084.95,398.971 2113.2,417.017 2133.82,430.189C2147.27,438.779 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z",
    style: {
      fill: "rgb(255,200,161)"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2043.18,508.696L2108.7,445.788L2075.66,421.558C2073.31,420.364 2070.36,419.725 2068.33,419.893L2058.58,413.585L2084.95,398.971C2084.95,398.971 2113.2,417.017 2133.82,430.189C2147.27,438.779 2190.04,508.717 2190.04,508.717L2138.03,589.003C2138.03,589.003 2109.35,572.639 2096.16,565.11C2091.85,562.654 2087.98,559.504 2084.7,555.786C2072.73,542.206 2043.18,508.696 2043.18,508.696Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2074.89,417.109C2074.89,417.109 2113.49,442.598 2108.6,445.733L2066.22,422.191L2060.12,419.893C2060.12,419.893 2060.12,419.893 2060.12,419.893C2063.86,417.125 2068.57,416.009 2073.15,416.806C2074.18,416.984 2074.89,417.109 2074.89,417.109Z",
    style: {
      fill: "rgb(240,159,104)"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.950048,1.77606e-17,-2.72562e-17,0.989488,-174.727,-437.869)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-7714.19,-7091.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4811.42,3612.69C4811.42,3577.23 4783.56,3548.48 4749.2,3548.48C4679.06,3548.48 4565.69,3548.48 4495.55,3548.48C4461.19,3548.48 4433.33,3577.23 4433.33,3612.69C4433.33,3666.9 4433.33,3744.12 4433.33,3798.32C4433.33,3833.79 4461.19,3862.54 4495.55,3862.54L4749.2,3862.54C4783.56,3862.54 4811.42,3833.79 4811.42,3798.32C4811.42,3744.12 4811.42,3666.9 4811.42,3612.69Z",
    style: {
      fill: "rgb(196,201,216)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-7727.73,-7094.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4562.13,
    cy: 3588.55,
    r: 7.44,
    style: {
      fill: "rgb(173,180,202)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-7501.63,-7094.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4562.13,
    cy: 3588.55,
    r: 7.44,
    style: {
      fill: "rgb(173,180,202)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59144,0,0,1.51478,-6797.82,-4622.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4433.33,
    y: 3548.48,
    width: 378.089,
    height: 314.059,
    style: {
      fill: "rgb(207,211,223)"
    }
  }), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4433.33,
    y: 3548.48,
    width: 378.089,
    height: 314.059
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12457,0,0,1.43248,-575.815,-1629.78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4676.09,
    y: 3724.52,
    width: 109.631,
    height: 104.866,
    style: {
      fill: "rgb(165,173,196)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19479,0,0,1.46645,-914.926,-1705.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4416.11,
    y: 3690.14,
    width: 423.5,
    height: 101.747,
    style: {
      fill: "none",
      stroke: "rgb(165,173,196)",
      strokeWidth: "14.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19479,0,0,1.46645,-914.926,-1855.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4416.11,
    y: 3690.14,
    width: 423.5,
    height: 101.747,
    style: {
      fill: "none",
      stroke: "rgb(165,173,196)",
      strokeWidth: "14.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.31597e-17,1.46645,-1.19479,8.97941e-17,8971.06,-3081.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4416.11,
    y: 3690.14,
    width: 423.5,
    height: 101.747,
    style: {
      fill: "none",
      stroke: "rgb(165,173,196)",
      strokeWidth: "14.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.31597e-17,1.46645,-1.19479,8.97941e-17,9092.63,-3081.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4416.11,
    y: 3690.14,
    width: 423.5,
    height: 101.747,
    style: {
      fill: "none",
      stroke: "rgb(165,173,196)",
      strokeWidth: "14.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.31597e-17,1.46645,-1.19479,8.97941e-17,9214.2,-3081.01)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4416.11,
    y: 3690.14,
    width: 423.5,
    height: 101.747,
    style: {
      fill: "none",
      stroke: "rgb(165,173,196)",
      strokeWidth: "14.05px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.534699,-9.5975e-18,1.58317e-17,0.551833,-42.9546,97.6494)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.17776,-5.38316e-34,1.61495e-33,2.53871,-11764.1,-7744.27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6021.85,3705.43L6147.31,3830.9",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "15.08px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.00182e-15,-2.53871,2.17776,4.66511e-15,-6719.5,17269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6021.85,3705.43L6147.31,3830.9",
    style: {
      fill: "none",
      stroke: "rgb(14,27,91)",
      strokeWidth: "15.08px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-7714.19,-7091.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4551.79,3592.93C4551.65,3592.94 4551.52,3592.94 4551.39,3592.94C4542.93,3592.94 4535.04,3589.08 4528.7,3582.27C4520.18,3573.12 4514.46,3558.41 4514.46,3541.76C4514.46,3525.11 4520.18,3510.41 4528.7,3501.25C4535.04,3494.45 4542.93,3490.59 4551.39,3490.59C4559.84,3490.59 4567.73,3494.45 4574.07,3501.25C4582.6,3510.41 4588.31,3525.11 4588.31,3541.76C4588.31,3544.04 4588.2,3546.28 4588,3548.48L4575.44,3548.48L4575.5,3547.84C4575.71,3545.86 4575.81,3543.83 4575.81,3541.76C4575.81,3528.66 4571.63,3516.97 4564.92,3509.77C4561.11,3505.67 4556.48,3503.09 4551.39,3503.09C4546.3,3503.09 4541.67,3505.67 4537.85,3509.77C4531.14,3516.97 4526.96,3528.66 4526.96,3541.76C4526.96,3554.87 4531.14,3566.55 4537.85,3573.76C4541.67,3577.85 4546.3,3580.47 4551.39,3580.47C4551.61,3580.47 4552.04,3580.47 4552.04,3580.47C4555.45,3580.5 4558.21,3583.28 4558.21,3586.7C4558.21,3590.14 4555.42,3592.94 4551.98,3592.94C4551.92,3592.94 4551.85,3592.94 4551.79,3592.93Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.78968,0,0,2.16989,-7714.19,-7091.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4678.61,3592.93C4678.46,3592.94 4678.31,3592.94 4678.16,3592.94C4669.71,3592.94 4661.82,3589.08 4655.48,3582.27C4646.96,3573.12 4641.24,3558.41 4641.24,3541.76C4641.24,3525.11 4646.96,3510.41 4655.48,3501.25C4661.82,3494.45 4669.71,3490.59 4678.16,3490.59C4686.62,3490.59 4694.51,3494.45 4700.85,3501.25C4709.37,3510.41 4715.09,3525.11 4715.09,3541.76C4715.09,3544.04 4714.98,3546.28 4714.78,3548.48L4702.21,3548.48L4702.28,3547.84C4702.48,3545.86 4702.59,3543.83 4702.59,3541.76C4702.59,3528.66 4698.41,3516.97 4691.7,3509.77C4687.89,3505.67 4683.26,3503.09 4678.16,3503.09C4673.07,3503.09 4668.44,3505.67 4664.63,3509.77C4657.92,3516.97 4653.74,3528.66 4653.74,3541.76C4653.74,3554.87 4657.92,3566.55 4664.63,3573.76C4668.44,3577.85 4673.1,3580.47 4678.19,3580.47C4678.41,3580.47 4678.82,3580.47 4678.82,3580.47L4678.83,3580.47C4682.27,3580.47 4685.06,3583.26 4685.06,3586.7C4685.06,3590.14 4682.27,3592.94 4678.83,3592.94C4678.76,3592.94 4678.68,3592.94 4678.61,3592.93Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.598186,-1.0737e-17,1.53109e-17,0.533683,150.788,565.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.599825,-1.07665e-17,1.53529e-17,0.535145,150.199,791.159)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.60456,-1.08514e-17,1.54741e-17,0.539369,342.8,561.675)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.597702,-1.07283e-17,1.52985e-17,0.53325,346.514,791.198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.597794,-1.073e-17,1.53009e-17,0.533333,539.074,565.213)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,1.42688,-1.01736,1.42688,-1037.76,-2050.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01736,-1.42688,0.624717,0.876185,-1506.47,2766.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1622.01,
    y: 138.071,
    width: 16.96,
    height: 157.433,
    style: {
      fill: "white"
    }
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyFailedSched);
export default __webpack_public_path__ + "static/media/guy_failed_sched.117858d81aa4e486594352e8ed571530.svg";
export { ForwardRef as ReactComponent };